<template>
  <div class="tower-show-page" id="towerInfo">
    <iframe
      id="iframe"
      width="100%"
      allowfullscreen="true"
      :src="myURL"
      frameborder="no"
      style="border: 0; height: 99%"
    ></iframe>
  </div>
</template>

<script>
import myHttp from "../../../untils/port";
import util from "../../../untils/util";
export default {
  data() {
    return {
      myURL: "/webgl/towerConfig.html",
      fullscreen: false,
    };
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown, false);
    window.addEventListener("message", this.handleMessage);

    this.$message({
      showClose: true,
      dangerouslyUseHTMLString: true,
      message: "<p>按下F11可以切换全屏/正常显示</p>",
    });
  },
  beforeDestroy() {},
  methods: {
    keyDown(event) {
      const e = event || window.event;
      if (e && e.keyCode === 122) {
        e.preventDefault();
        if (this.fullscreen) {
          this.exitFull(1);
        } else {
          this.handleFullScreen();
        }
      }
      if (e && e.keyCode === 27) {
        //esc退出全屏动作
        this.exitFull(0);
      }
    },
    // 按钮退出全屏
    exitFull(flag) {
      if (this.fullscreen == false) {
        return;
      }
      this.fullscreen = false;
      let element = document.getElementById("towerInfo");
      const runExit =
        element.exitFullscreen ||
        element.mozCancelFullScreen ||
        element.webkitExitFullscreen ||
        element.msExitFullscreen;
      // console.log(runExit);

      if (runExit) runExit.call(element);
      else {
        if(flag == 1){
          this.handleFullScreen();
        }
      }
    },
    handleFullScreen() {
      if (this.fullscreen == true) {
        return;
      }
      this.fullscreen = true;
      let element = document.getElementById("towerInfo");
      const runfullScreen =
        element.requestFullscreen ||
        element.mozRequestFullScreen ||
        element.webkitRequestFullScreen ||
        element.msRequestFullscreen;

      if (runfullScreen) runfullScreen.call(element);
      else {
        console.error("当前浏览器不支持部分全屏！");
      }
    },
    handleMessage(event) {
      // console.log(event, "事件");
      if (event.data.status === "ok") {
        if (event.data.params.status == 1) {
          if (this.fullscreen) {
            this.exitFull(1);
          } else {
            this.handleFullScreen();
          }
        } else {
          this.exitFull(0);
        }
        // console.log(event.data.params, "参数值");
      }
    },
  },
};
</script>

<style scoped>
.tower-show-page {
  margin-top: 0.2vw;
  margin-left: 0.2vw;
  width: 99.8%;
  height: 99.6%;
  position: relative;
}
</style>


<style>
.monitor-popper-class {
  min-width: 0;
  width: 88px !important;
  padding: 4px 4px;
}
</style>